export default "__VITE_ASSET__3Hk1KPJw__"